module.exports = __webpack_public_path__ + "static/v_5-b6088ffccc2f337969183a0fda000e67.mp4";